import { render, staticRenderFns } from "./membercardlist.vue?vue&type=template&id=50aa1708"
import script from "./membercardlist.vue?vue&type=script&lang=js"
export * from "./membercardlist.vue?vue&type=script&lang=js"
import style0 from "./membercardlist.vue?vue&type=style&index=0&id=50aa1708&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports